import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { ITicketBoard } from '../../../../../interfaces/models/ticket.interfaces'
import { societyQueries } from '../../../../../api/societies'
import { TicketAvatar } from '../../../../../components/common/Avatar'
import { formatDate } from '../../../../../helpers/date'
import { theme } from '../../../../../theme/theme'
import { cn } from '../../../../../helpers/utils'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'

export const TicketInformation = ({
  ticket,
  className,
}: {
  ticket: ITicketBoard
  className: string
}): React.ReactNode => {
  const { data: societyUsers } = useQuery(
    societyQueries.getSocietyIdUsers(ticket.societyId)
  )
  const { translate } = useAppTranslation()
  const customer = societyUsers?.find(
    (user) => user._id === ticket.customer?.id
  )
  const author = societyUsers?.find((user) => user._id === ticket.authorId)
  return (
    <section className={cn(className)}>
      {author && (
        <div className="mb-4">
          <p style={theme.textVariants.baseBold}>
            {translate('ticketBoardSidebar.createdByLabel')}
          </p>
          <div className="flex gap-2 items-center">
            <TicketAvatar user={author} url={author?.avatarUrl} />
            <div>
              <p style={theme.textVariants.base}>{author?.fullName}</p>
              <p style={theme.textVariants.base}>{author?.unitString}</p>
              <p style={theme.textVariants.base}>
                {formatDate(ticket.createdAt, 'long')}
              </p>
            </div>
          </div>
        </div>
      )}
      {customer && (
        <div className="mb-4">
          <p style={theme.textVariants.baseBold}>
            {translate('ticketBoardSidebar.customerLabel')}
          </p>
          <div className="flex gap-2 items-center">
            <TicketAvatar user={customer} url={customer?.avatarUrl} />
            <div>
              <p style={theme.textVariants.base}>{customer?.fullName}</p>
              <p style={theme.textVariants.base}>{customer?.unitString}</p>
            </div>
          </div>
        </div>
      )}
      {ticket.title && (
        <div className="mb-4">
          <p style={theme.textVariants.baseBold}>
            {translate('ticketBoardSidebar.titleLabel')}
          </p>
          <p style={theme.textVariants.base}>{ticket.title}</p>
        </div>
      )}
      {ticket.description && (
        <div className="mb-4">
          <p style={theme.textVariants.baseBold}>
            {translate('ticketBoardSidebar.descriptionLabel')}
          </p>
          <p
            style={theme.textVariants.base}
            className="max-h-48 overflow-y-auto whitespace-pre-line"
          >
            {ticket.description}
          </p>
        </div>
      )}
    </section>
  )
}
